<template>
  <div>
    <component
      :is="sidebarSetting.component"
      v-for="sidebarSetting in sidebarSettings"
      :key="sidebarSetting.component.name"
    />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import {
  SIDEBAR_SETTINGS,
} from '@/views/builder/builderComponentDefinitions'

@Component({})
export default class SidebarSettingsView extends Vue {
  get sidebarSettings () {
    return SIDEBAR_SETTINGS.filter(x => x.appTypes.includes(this.$typedStore.primary.app.app.appType!))
  }
}
</script>
